module.exports = __webpack_public_path__ + "assets/img/block-left-0fb41774.png";